import { createReducer } from 'deox';
import produce from 'immer';
import { BalanceState } from './types';
import { getBalanceAction, createBalanceAction } from './actions';

const initialState: BalanceState = {
  isLoading: {
    list: false,
    createBalance: false,
    createOperation: false,
  },
  errors: {
    list: null,
    createBalance: null,
    createOperation: null,
  },
  balance: null,
};

export const balanceReducer = createReducer(initialState, handle => [
  // Обработка получения баланса
  handle(getBalanceAction.request, state =>
    produce(state, draft => {
      draft.isLoading.list = true;
      draft.errors.list = null;
    }),
  ),
  handle(getBalanceAction.success, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.list = false;
      draft.errors.list = null;
      draft.balance = payload;
    }),
  ),
  handle(getBalanceAction.failure, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.list = false;
      draft.errors.list = payload;
    }),
  ),

  // Обработка создания баланса
  handle(createBalanceAction.request, state =>
    produce(state, draft => {
      draft.isLoading.createBalance = true;
      draft.errors.createBalance = null;
    }),
  ),
  handle(createBalanceAction.success, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.createBalance = false;
      draft.errors.createBalance = null;
      draft.balance = payload;
    }),
  ),
  handle(createBalanceAction.failure, (state, { payload }) =>
    produce(state, draft => {
      draft.isLoading.createBalance = false;
      draft.errors.createBalance = payload;
    }),
  ),

  // Обработка создания операции
  // handle(createOperationAction.request, state =>
  //   produce(state, draft => {
  //     draft.isLoading.createOperation = true;
  //     draft.errors.createOperation = null;
  //   }),
  // ),
  // handle(createOperationAction.success, (state, { payload }) =>
  //   produce(state, draft => {
  //     draft.isLoading.createOperation = false;
  //     draft.errors.createOperation = null;
  //     // добавляем новую операцию в список операций
  //     if (draft.balance) {
  //       draft.balance.operations.push(payload);
  //     }
  //   }),
  // ),
  // handle(createOperationAction.failure, (state, { payload }) =>
  //   produce(state, draft => {
  //     draft.isLoading.createOperation = false;
  //     draft.errors.createOperation = payload;
  //   }),
  // ),
]);
